'use client'

import Link from 'next/link'
import { motion } from 'framer-motion'
import FullBleedSection from './FullBleedSection'

export default function CallToAction() {
  return (
    <FullBleedSection className="mt-0 mb-24 bg-[#212121] px-4 py-32 md:mt-0 md:mb-32 md:px-4 md:py-25">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
        className="w-full"
      >
        <div className="grid gap-12 text-center md:grid-cols-2 md:items-center md:text-left">
          <div className="space-y-4">
            <h2 className="text-4xl font-bold text-white md:text-5xl">
              <span className="text-[#ff4500]">Deutsche</span>
              <br />
              Handwerks-Qualität
              <br />
              kann auch günstig sein!
            </h2>
            <Link
              href="/termin"
              className="mt-2 inline-block rounded-lg bg-[#ff4500] px-8 py-4 font-bold text-white transition-all hover:scale-105 hover:bg-[#e03e00]"
            >
              Jetzt beraten lassen
            </Link>
          </div>
          <div className="text-lg text-gray-200">
            <ul>
              <li>
                Lassen Sie sich kostenfrei beraten! Sie profitieren aus rund 20 Jahren
                Praxis-Erfahrung.
              </li>{' '}
              <li className="mt-4">
                Wir bieten keine One-fits-all-Lösung, sondern passen uns an Ihre Bedürfnisse an. Sie
                können mit einem günstigen Preis rechnen und attraktiven Lösungen, die Ihre
                Energiekosten massiv senken.
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </FullBleedSection>
  )
}
